<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="productHistory"
      style="width: 100%"
      row-key="id"
      border
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      productHistory() {
        return this.$store.getters['productHistory/productHistory'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['productHistory/tableConfig']));
      },
      loading() {
        return this.$store.getters['productHistory/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('productHistory/setFilterString', '');
      this.$store.commit('productHistory/setSorting', this.currentSort);
      await this.$store.dispatch('productHistory/fetchAll');
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('productHistory/setSorting', { prop, order });
          this.$store.dispatch('productHistory/fetchAll');
        }
      },
      getSum(params) {
        let result = [];
        let netSum = 0;
        let grossSum = 0;
        params.data.forEach(productHistory => {
          netSum += productHistory.net_sum;
          grossSum += productHistory.gross_sum;
        });
        result = params.columns.map((column, index) => {
          if(index === 0) {
            return 'Össz.:';
          }
          if(column.property === 'net_sum') {
            return this.$options.filters.currency(netSum.toFixed(2));
          }
          if(column.property === 'gross_sum') {
            return this.$options.filters.currency(grossSum.toFixed(2));
          }
          return '';
        });
        return result;
      },
    },
  };
</script>
<style lang="scss">
  .productHistory-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
